export default "__VITE_ASSET__D0wy7p0z__"